<template>
  <owa-modal-frame
    component-class="build-awesome"
    style="--card-roomy-horizontal-padding: var(--spacing-xl); --modal-margin-top: var(--spacing-6xl)"
    :is-showing="isShowing"
    @close-modal="$emit('close-modal')"
  >
    <div
      class="header"
      style="
        margin: calc(var(--card-roomy-vertical-padding) * -1) calc(var(--card-roomy-horizontal-padding) * -1) var(--card-roomy-vertical-padding);
        border-radius: var(--card-border-radius) var(--card-border-radius) 0 0;
        overflow: hidden;
        position: relative;
      "
    >
      <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%">
        <img
          src="/images/build-awesome-placeholder.png"
          alt="Build Awesome by Font Awesome"
        />
      </div>
      <div
        class="ba-kickstarter-video"
        style="padding: 56.25% 0 0 0; position: relative"
      >
        <iframe
          v-if="isShowing"
          src="https://player.vimeo.com/video/1168551192?h=6ba669b3ff&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
          title="Now on Kickstarter: Build Awesome - Collaborate on Web Sites That Last"
        ></iframe>
      </div>
    </div>
    <h2 class="h3 margin-bottom-md">
      <strong>Introducing <span style="color: var(--brand-build-awesome-green)">Build Awesome!</span></strong>
    </h2>

    <p class="margin-bottom-md">
      Build Awesome is a new way to build fast, beautiful websites. Open-source at its core, but now with endless Pro 'possum-bilities. (And it works perfectly with Font Awesome!) 
    </p>
    <a
      class="button block margin-bottom-xs margin-top-xl"
      href="https://www.kickstarter.com/projects/fontawesome/build-awesome?ref=91katr"
      target="_blank"
      style="--button-hover-background: #ade1c6"
    >
      <span>Check Out the Build Awesome Kickstarter!</span>
      <font-awesome-icon
        :icon="$v6.solid.faArrowUpRightFromSquare"
        class="margin-left-3xs"
        size="lg"
      />
    </a>
  </owa-modal-frame>
</template>

<script>
  import { ModalFrameMixin } from 'app/components-wa/modals/ModalFrame'

  export default {
    name: 'ModalBuildAwesomeKickstarter',

    mixins: [ModalFrameMixin]
  }
</script>
